module.exports = __webpack_public_path__ + "media/img/frontend_application/nogroup-2b37791d1b6b584d284fc58998eb41c2.png";